import { RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

import { Table } from './Table';

type TSLAProps = {};

export const SLA: React.FC<React.PropsWithChildren<TSLAProps>> = () => {
  return (
    <RouteWrapper>
      <section>
        <Subtitle>SLAs de los Crehana Products</Subtitle>
        <p>
          En este documento definiremos el detalle de los niveles de servicio
          que garantizamos a nuestros clientes para los siguientes productos.
        </p>
      </section>
      <section>
        <Subtitle>
          1. Aprendizaje, Gestión de capacitación LMS, Experiencia de
          Aprendizaje LXP.
        </Subtitle>
        <Table
          columns={[
            { field: 'type', headerName: 'Tipo de atención' },
            { field: 'channel', headerName: 'Canal' },
            { field: 'disponibility', headerName: 'Disponibilidad' },
          ]}
          rows={[
            {
              id: 1,
              type: 'Atención automatizada (Chatbot y Help Center)',
              channel: 'Web messenger (esquina inferior derecha del sitio Web)',
              disponibility: 'Las 24 horas durante los 7 días de la semana.',
            },
            {
              id: 2,
              type: 'Soporte humano vía Chat',
              channel: 'Web messenger (esquina inferior derecha del sitio Web)',
              disponibility:
                'Disponible de Lunes a Viernes desde las 9:00 A.M. hasta las 6:00 P.M (UTC-5)',
            },
            {
              id: 3,
              type: 'Soporte humano por correo electrónico',
              channel:
                'Soporte a través del correo <span class="tw-font-semibold">soportelearning@crehana.com</span>',
              disponibility:
                'Disponible de Lunes a Viernes desde las 9:00 A.M. hasta las 6:00 P.M (UTC-5)',
            },
          ]}
        />
      </section>
      <section>
        <Subtitle>
          2. Talento:
          <span className="font-normal"> Desempeño y Clima</span>
        </Subtitle>
        <Table
          columns={[
            { field: 'type', headerName: 'Tipo de atención' },
            {
              field: 'channel',
              headerName: 'Canal',
            },
            {
              field: 'disponibility',
              headerName: 'Disponibilidad',
            },
          ]}
          rows={[
            {
              id: 1,
              type: 'Soporte humano vía Chat',
              channel: 'Web messenger (esquina inferior derecha del sitio Web)',
              disponibility:
                'Disponible de Lunes a Viernes desde las 9:00 A.M. hasta las 6:00 P.M (UTC-5) con un plazo de  respuesta no mayor de 3 días hábiles',
            },
            {
              id: 2,
              type: 'Soporte humano por correo electrónico',
              channel:
                'Soporte a través del correo <span class="tw-font-semibold">soportetalent@crehana.com</span>',
              disponibility:
                'Disponible de Lunes a Viernes desde las 9:00 A.M. hasta las 6:00 P.M (UTC-5) con un plazo de respuesta no mayor de 3 días hábiles',
            },
          ]}
        />
      </section>
      <section>
        <Subtitle>3. LMS campus</Subtitle>

        <Table
          columns={[
            { field: 'type', headerName: 'Tipo de atención' },
            {
              field: 'channel',
              headerName: 'Canal',
            },
            {
              field: 'disponibility',
              headerName: 'Disponibilidad',
            },
          ]}
          rows={[
            {
              id: 1,
              type: 'Soporte humano por  correo electrónico',
              channel:
                'Soporte a través del correo <span class="tw-font-semibold">soportecampus@crehana.com</span>',
              disponibility:
                'Disponible de Lunes a Viernes desde las 9:00  A.M. hasta las 6:00 P.M (UTC-5) con un plazo de  respuesta no mayor de 1 día hábil',
            },
          ]}
        />
      </section>
      <section>
        <h3 className="mb-16">4. Full suite</h3>
        <p>Acceso a todos los canales de soporte relacionados anteriormente</p>
        <Subtitle>
          Soporte relacionado con problemas tecnológicos (Flujo y SLA)
        </Subtitle>
        <p>
          Los problemas técnicos se pueden informar a través de cualquiera de
          los canales de soporte y por parte del Customer Sucess Manager, en
          todos los casos estos tiempos empezarán a contar desde que
          efectivamente se registre el incidente en el sistema de gestión de
          incidencias de Crehana y se genere el número de ticket
          correspondiente:
        </p>
        <Table
          columns={[
            { field: 'type', headerName: 'Tipo de incidente' },
            { field: 'description', headerName: 'Descripción' },
            { field: 'time', headerName: 'Tiempos de respuesta' },
          ]}
          rows={[
            {
              id: 1,
              type: 'Incidentes de prioridad Crítica',
              description:
                'Son aquellos que impiden el acceso a la plataforma al 100% de los usuarios o incidentes críticos de seguridad informática',
              time: '8 horas hábiles',
            },
            {
              id: 2,
              type: 'Incidentes de prioridad Media',
              description:
                'Son aquellos que impiden el normal cumplimiento de un flujo de trabajo crítico o relevante (ejemplos: inscripción a cursos, avance dentro de cursos, rendir exámenes, búsqueda de cursos en el catálogo). Crehana analizará el caso según el SLA de Tiempo de Respuesta correspondiente al tipo de suscripción y asignará este nivel de criticidad en caso de detectar que se trate de un incidente general y no de un caso particular',
              time: '16 horas hábiles',
            },
            {
              id: 3,
              type: 'Incidentes de prioridad Baja',
              description:
                'Todo el resto de los incidentes que no cumplan con la condición de Prioridad Media o Crítica',
              time: '24 horas hábiles',
            },
            {
              id: 4,
              type: 'Sugerencias de mejoras en la plataforma',
              description:
                'Sujeto a disponibilidad y capacidad del equipo de tecnología',
              time: 'Definido por el equipo técnico después del análisis de lasolicitud',
            },
          ]}
        />
      </section>
    </RouteWrapper>
  );
};

export default SLA;
